// State of the „Szkoły, przedszkola i żłobki” layer, shared by the layer panel,
// the URL state and the point query without passing through index.js.
var layer = null;
var active = false;
var desired = false;
var controller = null;
var abortController = null;

export const educationLayerRuntime = {
    getLayer: function() { return layer; },
    setLayer: function(value) { layer = value; },
    getActive: function() { return active; },
    setActive: function(value) { active = !!value; },
    getDesired: function() { return desired; },
    setDesired: function(value) { desired = !!value; },
    getAbortController: function() { return abortController; },
    setAbortController: function(value) { abortController = value; },
    getController: function() { return controller; },
    setController: function(value) { controller = value; },
    /** Labels and the registry date of the latest answer (empty before the first one). */
    getMetadata: function() { return controller ? controller.getMetadata() : {}; },
    /** Ready for clicks: switched on and zoomed in far enough. */
    isQueryable: function() { return !!controller && controller.isActive() && controller.canActivate(); },
    getState: function() {
        return {
            educationActive: active,
            educationDesired: desired,
        };
    },
};
